'use strict';

export default function mainSearchForm () {
    let $searchToggle = $('.js-search-toggle'),
        $searchToToggle = $('.js-search-to-toggle'),
        $clearMainForm = $('.js-clear-main-form'),
        $mainForm = $('.js-main-search-form'),
        $cityChosen = $('.js-city-chosen'),
        $districtChosen = $('.js-district-chosen'),
        $districtHld = $('.js-district-select-hld');


    /* jshint camelcase:false */
    let loadDistricts = () => {
        let cityValues = $cityChosen.val();

        if (
            cityValues.length === 1 &&
            all_districts[cityValues[0]]
        ) {
            $districtChosen.empty();

            $.each(all_districts[cityValues[0]], (id, district) => {
                $districtChosen.append($('<option>')
                    .attr('value', id).text(district));
            });

            if (typeof selected_districts !== 'undefined') {
                $districtChosen.val(selected_districts);
            }

            $districtChosen.trigger('chosen:updated');

            $districtHld.show();
        } else {
            $districtChosen.empty();

            $districtChosen.trigger('chosen:updated');

            $districtHld.hide();
        }
    };
    /* jshint camelcase:true */

    if (
        $searchToggle.length &&
        $searchToToggle.length
    ) {
        $searchToggle.on('click', function (e) {
            e.preventDefault();

            let $this = $(this);

            $searchToToggle.toggle();

            $this.text($this.attr($this.hasClass('active') ? 'data-simple-label' : 'data-advanced-label')).toggleClass('active');
        });
    }

    if (
        $clearMainForm.length &&
        $mainForm.length
    ) {
        $clearMainForm.on('click', function (e) {
            e.preventDefault();

            $('.js-chosen-select').trigger('chosen:updated');

            $mainForm.find('input').first().focus();

            if ($searchToggle.hasClass('active')) {
                $searchToggle.trigger('click');
            }

        });
    }

    if (
        $cityChosen.length &&
        $districtChosen.length &&
        $districtHld.length
    ) {
        $cityChosen.on('change', loadDistricts);

        loadDistricts();
    }
}
